var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panels",
    { staticClass: "tapes-expansion" },
    _vm._l(_vm.items, function (item, id) {
      return _c(
        "v-expansion-panel",
        { key: id },
        [
          _c(
            "v-expansion-panel-header",
            { attrs: { "expand-icon": "mdi-plus" } },
            [
              _c("h2", { staticClass: "tapes-expansion__title" }, [
                _vm._v(_vm._s(item.title)),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("v-expansion-panel-content", [
            _c("p", {
              staticClass: "tapes-expansion__text",
              domProps: { innerHTML: _vm._s(item.text) },
            }),
          ]),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }